import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#0A0A0A] border-t border-[#16161F] py-12 px-4" data-id="element-102">
      <div className="max-w-4xl mx-auto text-center" data-id="element-103">
        <div className="text-[#FF6B00] text-2xl font-black tracking-widest mb-4 uppercase" data-id="element-104">
          🏀 BASKETBALL READY 360™
        </div>
        <p className="text-white text-base font-bold mb-2" data-id="element-105">
          The #1 system for basketball coaches worldwide.
        </p>
        <p className="text-[#B0B0C0] text-sm italic mb-8 font-medium" data-id="element-106">
          Because coaching shouldn't cost you every evening of the week.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-sm text-[#B0B0C0] mb-8 font-bold" data-id="element-107">
          <span className="hover:text-white transition-colors cursor-pointer" data-id="element-108">
            📧 support.basketballready360@gmail.com
          </span>
          <span className="hidden sm:inline text-[#333]" data-id="element-109">•</span>
          <span className="hover:text-white transition-colors cursor-pointer" data-id="element-110">
            📲 @basketballready360
          </span>
          <span className="hidden sm:inline text-[#333]" data-id="element-111">•</span>
          <span className="hover:text-white transition-colors cursor-pointer" data-id="element-112">
            🌐 www.basketballready360.com
          </span>
        </div>

        <div className="h-px bg-[#16161F] mb-8 w-full max-w-md mx-auto" data-id="element-113" />

        <p className="text-[#5A5A66] text-xs font-bold uppercase tracking-wider" data-id="element-114">
          © BASKETBALL READY 360™ 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}